import {
  CourseMaterial,
  useCoursesLoaderData,
  useProgramDetails,
} from "../coursesLoader";
import useMaterialOptDeadline from "../useMaterialOptDeadline";
import useOptedIn from "../useOptedIn";
import { useIntl } from "react-intl";

export default function useInclusiveAccessMaterialPrice(
  courseMaterial: CourseMaterial
) {
  const {
    userEffectiveProgram,
    allowsPrint,
    ia: { showPricing },
  } = useProgramDetails();
  const optedIn = useOptedIn(courseMaterial);
  const { optWindowOpen } = useMaterialOptDeadline(courseMaterial);
  const { currentTerm } = useCoursesLoaderData();
  const {
    verbaLicense,
    studentPrice,
    currency,
    purchaseLinks,
    materialFormat,
  } = courseMaterial;
  const intl = useIntl();

  const includesTax =
    verbaLicense &&
    verbaLicense.salesTaxEnabled &&
    !verbaLicense.salesTaxExempt &&
    verbaLicense.studentPriceWithTax > 0;

  const price = includesTax ? verbaLicense.studentPriceWithTax : studentPrice;
  const taxMessage = intl.formatMessage({ defaultMessage: "(includes tax)" });

  // An opted out student is only quoted a program price where opting back in is
  // actually offered, and never for print when the program excludes physical materials.
  const canOptIn =
    purchaseLinks.some((link) => link.type === "opt_in") &&
    !(materialFormat === "print" && !allowsPrint);
  const showForOptedIn = optedIn && optWindowOpen;
  const showForOptedOut =
    !optedIn &&
    canOptIn &&
    (optWindowOpen || !!currentTerm?.allowOptInAfterDeadline);

  if (
    userEffectiveProgram === "inclusive_access" &&
    showPricing &&
    (showForOptedIn || showForOptedOut) &&
    !verbaLicense?.hidePrice &&
    !!price
  ) {
    return `${intl.formatNumber(Number(price), {
      style: "currency",
      currency: currency ?? "USD",
    })} ${includesTax ? taxMessage : ""}`.trim();
  }
  return null;
}
